import { render, staticRenderFns } from "./chartsData.vue?vue&type=template&id=2d8488ae&scoped=true"
import script from "./chartsData.vue?vue&type=script&lang=js"
export * from "./chartsData.vue?vue&type=script&lang=js"
import style0 from "./chartsData.vue?vue&type=style&index=0&id=2d8488ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8488ae",
  null
  
)

export default component.exports